import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule, MatFormFieldModule, MatInputModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from '../../../../tooltip/tooltip.module';
import { ConfirmWithdrawalPopupCompoenent } from './confirm-withdrawal-popup.component';



@NgModule({
  entryComponents: [ConfirmWithdrawalPopupCompoenent],
  declarations: [ConfirmWithdrawalPopupCompoenent],
  imports: [
    CommonModule, MatFormFieldModule, FormsModule, ReactiveFormsModule, MatInputModule, MatButtonModule, TooltipModule
  ],
  exports: [ConfirmWithdrawalPopupCompoenent]
})
export class ConfirmWithdrawalPopupModule { }
